import React from 'react';
import CountUp from 'react-countup';
import { FaRupeeSign, FaUsers, FaBolt, FaShieldAlt } from 'react-icons/fa';
import './achievements.css';

const Achievements = () => {
  const achievementData = [
    {
      icon: <FaRupeeSign className="achievement-icon" />,
      value: 100,
      suffix: ' Cr+',
      label: 'Loans Disbursed',
      prefix: '₹',
      duration: 2,
    },
    {
      icon: <FaUsers className="achievement-icon" />,
      value: 50000,
      suffix: '+',
      label: 'Happy Borrowers',
      separator: ',',
      duration: 2,
    },
    {
      icon: <FaBolt className="achievement-icon" />,
      value: 5,
      suffix: ' Min',
      label: 'Instant Approvals',
      duration: 2,
    },
    {
      icon: <FaShieldAlt className="achievement-icon" />,
      value: 100,
      suffix: '%',
      label: 'Secure Process',
      duration: 2,
    },
  ];

  return (
    <section className="achievement-section py-5">
      <div className="container text-center">
        <h6 className="achievement-subtitle" data-aos="fade-up">
          Our Achievements
        </h6>
        <h2 className="achievement-title mb-4" data-aos="fade-up" data-aos-delay="100">
          Trusted by <span className="highlight">Thousands Across </span> the Country
        </h2>
        <p className="achievement-desc mb-5" data-aos="fade-up" data-aos-delay="200">
          Fast, secure loans with a customer-first approach.
        </p>

        <div className="row g-4 justify-content-center">
          {achievementData.map((item, index) => (
            <div className="col-6 col-sm-4 col-lg-3 d-flex" key={index} data-aos="zoom-in" data-aos-delay={100 * (index + 1)}>
              <div className="achievement-box w-100">
                <div className="icon mb-3">{item.icon}</div>
                <h3 className="count">
                  {item.prefix || ''}
                  <CountUp end={item.value} duration={item.duration} separator={item.separator || ''} />
                  {item.suffix}
                </h3>
                <p className="label">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
